/**
 * Cliente API de entes_externos para el portal (Sprint 18 P14).
 *
 * Tesorero ve listado + recursos asignados a cada ente (lectura) y puede
 * cargar un recurso donado al ente (S19 cabo #5, `require_tesorero`).
 * La edición del ente (alta/baja/edición) vive en `/sa` por D-P14-5.
 */
import { apiFetch } from './client';

export interface EnteExternoRead {
  id: string;
  nombre: string;
  contacto: string | null;
  notas: string | null;
  activo: boolean;
  creado_at: string;
  actualizado_at: string;
}

export interface RecursoDeEnteExternoRead {
  id: string;
  lote_id: string | null;
  ente_externo_id: string | null;
  tipo: string;
  identificador: string;
  costo_reposicion: number;
  entregado_at: string;
  estado: string;
  notas: string | null;
  // Serial RFID del llavero (desde stock_recursos vía join). null para CR/
  // otro o llaveros que aún no lo tienen cargado.
  serial_rfid: string | null;
}

export function listEntesExternos(
  filtros: { incluir_inactivos?: boolean } = {},
): Promise<EnteExternoRead[]> {
  const params = new URLSearchParams();
  if (filtros.incluir_inactivos) params.set('incluir_inactivos', 'true');
  const qs = params.toString();
  return apiFetch<EnteExternoRead[]>(
    `/entes-externos/${qs ? `?${qs}` : ''}`,
  );
}

export function listRecursosDeEnteExterno(
  id: string,
): Promise<RecursoDeEnteExternoRead[]> {
  return apiFetch<RecursoDeEnteExternoRead[]>(
    `/entes-externos/${id}/recursos`,
  );
}

// S19 cabo #5 — carga directa de un recurso donado a un ente externo (sin
// consumir stock, sin IngresoVario). Backend: crear_recurso_externo_directo.
export interface CrearRecursoExternoPayload {
  tipo: 'llavero' | 'control_remoto' | 'otro';
  identificador: string;
  costo_reposicion: number;
  entregado_at: string; // YYYY-MM-DD
  notas?: string | null;
  serial_rfid?: string | null; // H9: solo aplica a tipo=llavero
}

export function crearRecursoExternoDirecto(
  enteId: string,
  payload: CrearRecursoExternoPayload,
): Promise<RecursoDeEnteExternoRead> {
  return apiFetch<RecursoDeEnteExternoRead>(
    `/entes-externos/${enteId}/recursos`,
    { method: 'POST', body: JSON.stringify(payload) },
  );
}
